import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Link, useNavigate, useParams } from "react-router-dom";
import Card from "../../components/Card/Card";
import useAuth from "../../hooks/useAuth";
import {
  submitApplicationSchema,
  submitBusinessProfileSchema,
} from "../../services/SchemaService";

import {
  Column,
  Form,
  Loading,
  Row,
  TextArea,
  TextInput,
} from "carbon-components-react";
import SubmitButton from "../../components/Buttons/SubmitButton";
import CancelButton from "../../components/Buttons/CancelButton";
import { ButtonSet } from "carbon-components-react";
import { Edit24, Undo24 } from "@carbon/icons-react";
import { SendAlt24 } from "@carbon/icons-react";
import http from "../../http-common";
import { toast } from "react-toastify";
import useGet from "../../hooks/useGet";
// import useCandidature from "../../hooks/useCandidature";
import PersonalDataForm from "../../components/Forms/PersonalDataForm";
import TrainingAreaForm from "../../components/Forms/TrainingAreaForm";
import useCandidature from "../../hooks/useCandidature";
import BusinessDetailsForm from "../../components/Forms/BusinessDetailsForm";

const ViewCandidaturePage = () => {
  const { user, isCompetitor } = useAuth();
  const params = useParams();
  const [uuid] = useState(params.uuid);
  const { isLoading, candidature } = useCandidature(uuid);
  const [isOpen, setIsOpen] = useState(true);
  const [selectedBusinessPhases, setSelectedBusinessPhases] = useState([]);
  const [selectedWorkAreas, setSelectedWorkAreas] = useState([]);
  const [selectedTrainingProviders, setSelectedTrainingProviders] = useState(
    []
  );
  const [selectedTrainingAreas, setSelectedTrainingAreas] = useState([]);
  const [hasOwnBusiness, setHasOwnBusiness] = useState(false);
  const [isEmployed, setIsEmployed] = useState(false);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors, isSubmitted },
  } = useForm({
    resolver: yupResolver(submitApplicationSchema),
    mode: "onSubmit",
  });

  const onSubmit = async (data) => {
    try {
      navigate("../create-self-knowledge-questionnaire/" + uuid);
    } catch (error) {
      toast.error(error?.response?.data.message);
    }
  };

  useEffect(() => {
    reset(candidature);
    setSelectedBusinessPhases(candidature.businessPhases);
    setSelectedWorkAreas(candidature.workAreas);
    setSelectedTrainingProviders(candidature.pastTrainings);
    setSelectedTrainingAreas(candidature.trainingPreferences);
    setIsOpen(candidature.currentStageCode === 1);
  }, [candidature]);

  const getCandidatureUuid = async () => {
    try {
      const response = await http.get(
        `/applications/uuid-by-phone-number/${user.username}`
      );
      navigate(
        response.data
          ? "../candidature/" + response.data
          : "../create-candidature"
      );
    } catch (error) {
      navigate("../create-candidature");
    }
  };

  useEffect(() => {
    if (isSubmitted && Object.keys(errors).length > 0) {
      toast.error(
        "Erro de validação do formulário. Verifique se não tem campos obrigatórios não preenchidos"
      );
    }
  }, [isSubmitted, errors]);

  useEffect(() => {
    if (isCompetitor && uuid == "redirect") {
      getCandidatureUuid();
    }
  }, []);

  return (
    <>
      <Loading
        active={isLoading}
        description="Active loading indicator"
        withOverlay={true}
      />
      <Card title="Candidatura">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <PersonalDataForm
            register={register}
            control={control}
            errors={errors}
            disabled={true}
            candidature={candidature}
            hasOwnBusiness={true}
          />
          <BusinessDetailsForm
            register={register}
            control={control}
            errors={errors}
            disabled={true}
            candidature={candidature}
            selectedBusinessPhases={selectedBusinessPhases}
            setSelectedBusinessPhases={setSelectedBusinessPhases}
            selectedWorkAreas={selectedWorkAreas}
            setSelectedWorkAreas={setSelectedWorkAreas}
          />

          <TrainingAreaForm
            register={register}
            control={control}
            errors={errors}
            disabled={true}
            candidature={candidature}
            selectedTrainingProviders={selectedTrainingProviders}
            setSelectedTrainingProviders={setSelectedTrainingProviders}
            selectedTrainingAreas={selectedTrainingAreas}
            setSelectedTrainingAreas={setSelectedTrainingAreas}
          />

          <div className="form-buttons">
            <ButtonSet>
              {/* {isOpen && (
                <SubmitButton
                  type="button"
                  label="Editar"
                  className="emprega-bg-green"
                  icon={Edit24}
                  onClick={() => navigate("../update-candidature/" + uuid)}
                />
              )} */}
              <CancelButton
                navigateTo={isCompetitor ? "../home" : "../candidatures"}
                icon={Undo24}
                label="Voltar"
              />
            </ButtonSet>
            {/* {isOpen && (
              <ButtonSet>
                <SubmitButton label="Submeter" icon={SendAlt24} />
              </ButtonSet>
            )} */}
          </div>
        </Form>
      </Card>
    </>
  );
};

export default ViewCandidaturePage;
